import { render, staticRenderFns } from "./RecipientNew.vue?vue&type=template&id=8b69047c&scoped=true&"
import script from "./RecipientNew.vue?vue&type=script&lang=js&"
export * from "./RecipientNew.vue?vue&type=script&lang=js&"
import style0 from "./RecipientNew.vue?vue&type=style&index=0&id=8b69047c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8b69047c",
  null
  
)

export default component.exports